<template>
  <v-container style="max-width:100vw;" class="pa-0">
    <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="filterDrawer" app>
      <v-container class="ma-0 pa-0 pb-8">
        <div class="pt-6 px-8 pb-6">
          <v-row class="ma-0 mb-2">
            <strong>Filtros</strong>
            <v-spacer></v-spacer>
            <v-btn @click="removeFilters()" small class="elevation-0" style="border:solid 1px #dddddd;">
              <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
            </v-btn>
          </v-row>

          <v-text-field
            v-model="filters.product_name"
            label="Producto"
            clearable
            @keydown.enter="applyFilters()"
          ></v-text-field>

          <v-autocomplete
            v-model="filters.brand"
            :items="brands"
            item-text="name"
            item-value="id"
            attach
            chips
            label="Marca"
            multiple
            clearable
            @keydown.enter="applyFilters()"
          ></v-autocomplete>

          <v-autocomplete
            v-model="filters.category"
            :items="categories"
            item-text="name"
            item-value="id"
            attach
            chips
            label="Categoría"
            multiple
            clearable
            @keydown.enter="applyFilters()"
          ></v-autocomplete>
        </div>

        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
          <v-list-item link @click="applyFilters()" dark>
            <v-list-item-content>
              <strong>Filtrar ({{filtersLength}})</strong>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-container>
    </v-navigation-drawer>

    <v-card class="elevation-0 ma-8 py-6 px-8">
      <v-row class="ma-0 pb-4">
        <div>
          <v-card-title>
            Reporte de Productos Vendidos
          </v-card-title>
          <v-card-subtitle>Montos sin IVA</v-card-subtitle>
        </div>

        <v-btn icon class="ml-6 mt-4" v-if="filtersLength < 1" @click="openFilter()">
          <v-icon>mdi-filter</v-icon>
        </v-btn>
        <v-btn icon class="ml-6 mt-4" v-else @click="openFilter()">
          <v-badge overlap color="primary">
            <template v-slot:badge>
              {{filtersLength}}
            </template>
            <v-icon>mdi-filter</v-icon>
          </v-badge>
        </v-btn>

        <v-spacer/>
        <v-menu offset-y :close-on-content-click="closeDatePicker(dates)">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field rounded outlined dense clearable v-model="dates" label="Fecha" prepend-inner-icon="mdi-calendar" v-bind="attrs" readonly v-on="on" class="mt-4"></v-text-field>
          </template>
          <v-date-picker v-model="dates" range></v-date-picker>
        </v-menu>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="products"
        :loading="loading"
      >
        <template v-slot:[`item.total_amount`]="{ item }">
          {{money(item.total_amount)}}
        </template>
        <template v-slot:[`item.total_cost`]="{ item }">
          {{money(item.total_cost)}}
        </template>
        <template v-slot:[`item.utilidad`]="{ item }">
          {{money(item.utilidad)}}
        </template>
        <template v-slot:[`item.porcentaje_utilidad_costo`]="{ item }">
          {{percent(item.utilidad, item.total_cost)}}
        </template>
        <template v-slot:[`item.porcentaje_utilidad_venta`]="{ item }">
          {{percent(item.utilidad, item.total_amount)}}
        </template>
        <template v-slot:[`item.avg`]="{ item }">
          {{money(avg(item.total_amount, item.sales_count))}}
        </template>
        <template v-slot:[`item.avg_utilidad`]="{ item }">
          {{money(avg(item.utilidad, item.sales_count))}}
        </template>
        <template v-slot:[`item.avg_cost`]="{ item }">
          {{money(avg(item.total_cost, item.sales_count))}}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios"
export default {
    data(){
        return{
            filterDrawer:false,
            loading:false,
            dates:[],
            filters:this.defaultFilters(),
            products:[],
            headers:[
                { text: 'Código 1', value: 'code_one' },
                { text: 'Producto', value: 'name' },
                { text: 'Cantidad', value: 'sales_count' },
                { text: 'Costo Unitario', value: 'avg_cost' },
                { text: 'Precio Unitario', value: 'avg' },
                { text: 'Utilidad Unitaria', value: 'avg_utilidad' },
                { text: 'Costo Total', value: 'total_cost' },
                { text: 'Venta Total', value: 'total_amount' },
                { text: 'Utilidad Total', value: 'utilidad' },
                { text: '% Utilidad / Costo', value: 'porcentaje_utilidad_costo' },
                { text: '% Utilidad / Venta', value: 'porcentaje_utilidad_venta' }
            ]
        }
    },
    computed:{
        categories(){
            return this.$store.state.category.categories
        },
        brands(){
            return this.$store.state.brand.brands
        },
        filtersLength(){
            var count = 0
            if(this.filters.product_name !== '' && this.filters.product_name !== null && this.filters.product_name !== undefined){
                count++
            }
            if(this.filters.brand && this.filters.brand.length > 0){
                count++
            }
            if(this.filters.category && this.filters.category.length > 0){
                count++
            }
            return count
        }
    },
    created(){
        const savedFilters = localStorage.getItem('selectorFiltersItemsReport')
        if(savedFilters){
            this.filters = {
                ...this.defaultFilters(),
                ...JSON.parse(savedFilters),
            }
        }

        var dates = []
        var current_date = new Date()
        dates[0] = new Date(current_date.getFullYear(), current_date.getMonth(), 1).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)
        dates[1] = new Date(current_date.getFullYear(), current_date.getMonth() + 1, 0).toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).toString().slice(0, 10)
        this.dates = dates
    },
    watch:{
        dates:{
            handler(){
                if(this.dates.length==2){
                    this.getData()
                }
            }, deep:true
        }
    },
    methods:{
        defaultFilters(){
            return {
                product_name:'',
                brand:[],
                category:[],
            }
        },
        openFilter(){
            this.filterDrawer = !this.filterDrawer
        },
        applyFilters(){
            localStorage.setItem('selectorFiltersItemsReport', JSON.stringify(this.filters))
            localStorage.setItem('filtersItemsReportLength', this.filtersLength)
            this.filterDrawer = false
            this.getData()
        },
        removeFilters(){
            this.filters = this.defaultFilters()
            localStorage.removeItem('selectorFiltersItemsReport')
            localStorage.removeItem('filtersItemsReportLength')
            this.getData()
        },
        buildQuery(){
            const params = new URLSearchParams()
            params.set('filter[created_between]', this.dates.join(','))
            if(this.filters.product_name){
                params.set('filter[product_name]', this.filters.product_name)
            }
            if(this.filters.brand && this.filters.brand.length > 0){
                params.set('filter[brand_id]', this.filters.brand.join(','))
            }
            if(this.filters.category && this.filters.category.length > 0){
                params.set('filter[category_id]', this.filters.category.join(','))
            }
            return params.toString()
        },
        getData(){
            this.loading = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/item/report?" + this.buildQuery()).then(response=>{
                this.products = response.data
            }).finally(()=>{
                this.loading = false
            })
        },
        closeDatePicker(dates){
            if(dates!=undefined && dates.length==2){
                return true
            }else{
                return false
            }
        },
        money(value){
            return (value*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})
        },
        avg(total, count){
            if(!count || Number(count) === 0){
                return 0
            }
            return (total*1)/(count*1)
        },
        percent(total, base){
            if(!base || Number(base) === 0){
                return '0.00%'
            }
            return (((total*1) / (base*1)) * 100).toFixed(2) + '%'
        },
    }
}
</script>

<style>

</style>
